"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasCrosshairLines = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
exports.CanvasCrosshairLines = (0, react_1.memo)(function (_a) {
    var canvasSize = _a.canvasSize, pointerPos = _a.pointerPos, mode = _a.mode, crosshairLineColor = _a.crosshairLineColor, crosshairLineWidthPx = _a.crosshairLineWidthPx;
    var _b = tslib_1.__read((0, utils_1.useCanvasContext2d)(), 2), context = _b[0], canvasRef = _b[1];
    var twoLinesCurr = (0, react_1.useMemo)(function () {
        return !(pointerPos !== undefined &&
            (mode === 'rectbox-editor-standby' ||
                mode === 'rectbox-editor-add-bbox' ||
                mode === 'rectbox-editor-resize-bbox' ||
                mode === 'auto-segmentation-crop' ||
                mode === 'auto-segmentation-standby'))
            ? undefined
            : {
                horizontal: (0, utils_1.IRect)({
                    top: pointerPos.y,
                    left: 0,
                    width: canvasSize.width,
                    height: crosshairLineWidthPx
                }),
                vertical: (0, utils_1.IRect)({
                    top: 0,
                    left: pointerPos.x,
                    width: crosshairLineWidthPx,
                    height: canvasSize.height
                })
            };
    }, [pointerPos, mode, crosshairLineWidthPx, canvasSize]);
    var twoLinesPrev = (0, utils_1.usePrevious)(twoLinesCurr);
    (0, react_1.useEffect)(function () {
        if (context === undefined)
            return;
        window.requestAnimationFrame(function () {
            if (twoLinesPrev !== undefined) {
                // clear horizontal line
                context.clearRect(twoLinesPrev.horizontal.left, twoLinesPrev.horizontal.top, twoLinesPrev.horizontal.width, twoLinesPrev.horizontal.height);
                // clear vertical line
                context.clearRect(twoLinesPrev.vertical.left, twoLinesPrev.vertical.top, twoLinesPrev.vertical.width, twoLinesPrev.vertical.height);
            }
            if (twoLinesCurr !== undefined) {
                context.fillStyle = crosshairLineColor;
                // horizontal line
                context.fillRect(twoLinesCurr.horizontal.left, twoLinesCurr.horizontal.top, twoLinesCurr.horizontal.width, twoLinesCurr.horizontal.height);
                // vertical line
                context.fillRect(twoLinesCurr.vertical.left, twoLinesCurr.vertical.top, twoLinesCurr.vertical.width, twoLinesCurr.vertical.height);
            }
        });
    }, [twoLinesCurr, twoLinesPrev, crosshairLineColor, context]);
    return (react_1.default.createElement("canvas", { ref: canvasRef, height: canvasSize.height, width: canvasSize.width }));
});
exports.CanvasCrosshairLines.displayName = 'CanvasCrosshairLines';
